module.exports = __webpack_public_path__ + "media/images/icon__predict@2x-b3c89654a7a63871a606492729edc8f3.png";